import { createFileRoute } from '@tanstack/react-router';

import {
  dimensaSubmissionScreen,
  dimensaSubmissionSearch,
  loadDimensaSubmissionMessages,
  loadDimensaSubmissionScreens,
} from '@/modules/dimensa-submission/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Envios Dimensa no caminho do legado (`router.tsx:1256-1263`), sem menu (`showNav: false`). Arquivo leve
// (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/cessoes/submissoes-dimensa/')({
  validateSearch: dimensaSubmissionSearch,
  staticData: { screen: dimensaSubmissionScreen },
  loader: () => loadDimensaSubmissionMessages(),
  component: lazyScreen(loadDimensaSubmissionScreens, 'DimensaSubmissionRouteScreen'),
});
